import { ButtonBase, FormLabel, Grid } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import 'moment/locale/ja';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './DateTimePicker.scss';
import { DatePattern } from '@utils/constants';

const AppDateTimePicker: FC<AppDateTimePickerProps> = ({
  id,
  label,
  required,
  value,
  isRow = false,
  placeholder,
  format = DatePattern.DATE,
  onChange,
}) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const handleChange = (value: moment.Moment | null) => {
    if (value) {
      onChange?.(value.format(format));
    }
  };

  return (
    <Grid
      container
      className='DateTimePicker'
      direction={isRow ? 'row' : 'column'}
      spacing={isRow ? 3 : 2}
    >
      {label && (
        <Grid
          item
          xs={4}
          alignItems='center'
          justifyContent={isRow ? 'flex-end' : 'flex-start'}
        >
          <FormLabel htmlFor={id} required={required}>
            {t(label)}
          </FormLabel>
        </Grid>
      )}
      <Grid item xs={8}>
        <ButtonBase
          className='DateTimePickerButton'
          disableTouchRipple
          disabled={open}
          onClick={() => setOpen(true)}
        >
          <DateTimePicker
            open={open}
            views={['year', 'month', 'day']}
            slotProps={{
              textField: { placeholder: t(placeholder!) },
              toolbar: { hidden: true },
              actionBar: { actions: ['today', 'accept'] },
            }}
            timeSteps={{ minutes: 1, seconds: 1 }}
            format={format}
            value={value ? moment(value) : undefined}
            onClose={() => setOpen(false)}
            onChange={handleChange}
            localeText={{ todayButtonLabel: t('common.now') }}
          />
        </ButtonBase>
      </Grid>
    </Grid>
  );
};

export default AppDateTimePicker;
